
import { ITEM_TYPES } from '../../../item/item-types';
import { Collection } from '../../../collection/Collection';
import { Item } from '../../item/Item';

export class Leitner extends Item {
    constructor(collection: Collection) {
        super(collection);
        this.type = ITEM_TYPES.Leitner;
        this.title = collection.getTitle();
    }
} 